<template>
  <div class="upload">
    <div class="upload__header">
      <h2>{{ message }}</h2>
    </div>
    <div class="upload__body">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        center
        style="width: 100%;"
        :cell-style="cellStyle"
      >
        <el-table-column type="index" :index="indexMethod" />
        <el-table-column prop="wname" label="壁纸名称" width="180" />
        <el-table-column prop="price" label="壁纸定价" width="100" align="center" />
        <el-table-column
          prop="platform_type"
          label="壁纸类型"
          width="180"
          align="center"
          class-name="combine-column"
        >
          <template #default="scope">
            <div class="picType">
              <span class="pc">
                <!-- {{ scope.row.pc_info.platform_type }} -->
                PC壁纸
              </span>
              <span v-if="scope.row.mobile_info" class="line" />
              <span v-if="scope.row.mobile_info" class="mobile">
                <!-- {{ scope.row.mobile_info.platform_type }} -->
                手机壁纸
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="preview_jpg"
          label="预览图"
          width="180"
          align="center"
        >
          <template #default="scope">
            <div class="picType picPreview">
              <span
                class="pc"
                @click="scanPreviewImage(scope.row.pc_info.preview_jpg)"
              >
                <img
                  :src="scope.row.pc_info.preview_jpg"
                  style="width: 100%;"
                  alt="pc preview"
                >
              </span>
              <span v-if="scope.row.mobile_info" class="line" />
              <span
                v-if="scope.row.mobile_info"
                class="mobile"
                alt="mobile preview"
                @click="scanPreviewImage(scope.row.mobile_info.preview_jpg)"
              >
                <img
                  :src="scope.row.mobile_info.preview_jpg"
                  style="width: 100%;"
                >
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="download_cnt"
          label="下载量"
          width="100"
          align="center"
          class-name="combine-column"
        >
          <template #default="scope">
            <div class="picType">
              <span class="pc">
                {{ scope.row.pc_info.download_cnt }}
              </span>
              <span v-if="scope.row.mobile_info" class="line" />
              <span v-if="scope.row.mobile_info" class="mobile">
                {{ scope.row.mobile_info.download_cnt }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          class-name="combine-column"
        >
          <template #default="scope">
            <div v-if="scope.row.mobile_info" class="picType">
              <span class="pc">
                <el-button size="mini" @click="scanPreview(scope.row)">
                  预览视频
                </el-button>
              </span>
              <span class="line" />
              <span class="mobile">
                <el-button
                  size="mini"
                  :disabled="+scope.row.mobile_info.status === 2"
                  @click="uploadMobilePic(scope.row)"
                >
                  {{ picStatus[scope.row.mobile_info.status] }}
                </el-button>
              </span>
            </div>
            <div v-else class="picType__default">
              <el-button size="mini" @click="scanPreview(scope.row)">
                预览视频
              </el-button>
              <el-button size="mini" @click="uploadMobilePic(scope.row)">
                上传手机版
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="upload__footer">
      <!-- pagination -->
      <el-pagination
        :page-sizes="[10, 20, 30, 40]"
        :current-page="currentPage"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- dialog -->
    <el-dialog
      v-model:visible="showUploadModal"
      title="上传手机视频"
      width="650px"
      center
    >
      <Upload :params="currentPic" @submitPic="submitPicHandler" />
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Upload from './Upload'
import { getPaperList } from '@/api/upload'
const PIC_STATUS = {
  0: '下线',
  1: '上线',
  2: '审核中',
  3: '未通过审核',
  4: '审核通过，尚未入壁纸库',
  5: '资源准备中',
}
export default {
  name: 'MobileUpload',
  components: {
    Upload,
  },
  data() {
    return {
      loading: false,
      showUploadModal: false,
      message: '上传移动端壁纸',
      currentPic: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      picStatus: PIC_STATUS,
      tableData: [],
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      common: (state) => {
        return {
          token: state.userInfo.token,
          open_id: state.userInfo.open_id,
        }
      },
    }),
    userPtype() {
      return this.form.ptype
    },
    cellStyle() {
      return {
        height: '60px',
      }
    },
  },
  created() {
    this.getPaperList()
  },
  methods: {
    submitPicHandler() {
      this.showUploadModal = false
      this.getPaperList()
    },
    handleList(data) {
      // eslint-disable-next-line array-callback-return
      data.map((item) => {
        if (item.price === 0) {
          item.price = '免费'
        } else {
          item.price = item.price / 100
        }
      })
      this.tableData = data
    },
    getPaperList() {
      this.loading = true
      const requestData = {
        common: {
          token: this.common.token,
          open_id: this.common.open_id,
        },
        wtype_support: 0, // 0:只取动态壁纸。1:动态壁纸跟scene一起取，2: scene壁纸，3: 静态壁纸
        page: this.currentPage,
        page_size: this.pageSize,
      }
      getPaperList(requestData)
        .then((res) => {
          console.log(res)
          const { list, total } = res
          this.handleList(list)
          this.total = total
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
        })
    },
    indexMethod(index) {
      return index + 1
    },
    handleClick(row) {
      console.log(row)
    },
    scanPreviewImage(imgAddress) {
      if (imgAddress) {
        window.open(imgAddress)
      }
    },
    scanPreview(row) {
      if (row.pc_info.preview_video) {
        window.open(row.pc_info.preview_video)
      }
    },
    uploadMobilePic(row) {
      this.currentPic = row
      this.showUploadModal = true
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getPaperList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getPaperList()
    },
  },
}
</script>

<style lang="scss" scoped>
$mainColor: #f5b903;
.upload {
  position: relative;
  width: 1200px;
  min-height: 640px;
  margin: 0 auto;
  padding: 0 20px;
  background: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  overflow: hidden;
  &__header {
    text-align: center;
    margin: 10px 0;
  }
  &__body {
    .picType {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      span {
        text-align: left;
      }
      .pc,
      .mobile {
        display: block;
        margin: 0 auto;
        position: relative;
        // margin-bottom: 12px;
        img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .mobile {
        margin-top: 12px;
      }
      .line {
        position: absolute;
        left: 0;
        top: 50%;
        width: 100%;
        height: 1px;
        background-color: #ebeef5;
      }
    }
    .picPreview {
      .pc,
      .mobile {
        width: 60px;
        height: 60px;
        cursor: pointer;
        overflow: hidden;
      }
    }
  }
  &__footer {
    margin: 20px;
    text-align: right;
  }
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: $mainColor;
  }
  ::v-deep .el-table td {
    padding: 0;
  }
  ::v-deep .el-dialog {
    border-radius: 10px;
  }
  ::v-deep .combine-column {
    .cell {
      height: 100%;
      .picType__default {
        line-height: 60px;
      }
    }
  }
  ::v-deep .el-loading-mask {
    z-index: 20;
  }
}
</style>
